





// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals";

// const Updateservice = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const initialData = location.state?.responseData || {};
//   const [editableData, setEditableData] = useState(initialData);

//   useEffect(() => {
//     console.log("Received Data for Update:", editableData);
//   }, [editableData]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditableData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   const handleSaveChanges = async () => {
//     if (!editableData.ID || !editableData.ServiceName) {
//       toast.warn("⚠️ ID and Service Name are required.");
//       return;
//     }

//     const whereCondition = `ID=${editableData.ID}`;

//     // ✅ Create form data for POST
//     const updateData = new URLSearchParams();
//     updateData.append("SecurityKey", SECURITY_KEY);
//     updateData.append("TableName", "ServiceMast");
//     updateData.append("WhereCondition", whereCondition);

//     Object.entries(editableData).forEach(([key, value]) => {
//       if (value !== undefined && value !== null && key !== "ID") {
//         updateData.append(key, value.toString());
//       }
//     });

//     try {
//       const response = await fetch(
//         "https://etour.responseinfoway.com/restapi/updatedata.aspx",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded",
//             Accept: "application/json",
//           },
//           body: updateData.toString(),
//         }
//       );

//       const textResponse = await response.text();
//       console.log("Raw API Response:", textResponse);

//       // ✅ Consider any response without "error" as success
//       if (
//         textResponse.toLowerCase().includes("ok") ||
//         textResponse.toLowerCase().includes("success") ||
//         !textResponse.toLowerCase().includes("error")
//       ) {
//         toast.success("Data updated successfully!");
//         setTimeout(() => {
//           navigate("/showservice", { state: { updatedItem: editableData } });
//         }, 100);
//       } else {
//         toast.error("❌ Update failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Update error:", error);
//       toast.error("❌ Network or server error!");
//     }
//   };

//   return (
//     <div className="update-container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
//       <h1>🔄 Update Service</h1>

//       <form>
//         <div className="input-group d-none">
//           <input type="text" name="ID" value={editableData.ID || ""} readOnly />
//         </div>

//         <div className="input-group">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="ServiceName"
//             value={editableData.ServiceName || ""}
//             onChange={handleInputChange}
//           />
//         </div>

//         <div className="input-group">
//           <label>HSN Code</label>
//           <input
//             type="text"
//             name="HSNCODE"
//             value={editableData.HSNCODE || ""}
//             onChange={handleInputChange}
//           />
//         </div>

//         <button
//           type="button"
//           className="save-changebtn"
//           onClick={handleSaveChanges}
//         >
//           ✅ Save Changes
//         </button>
//       </form>
//     </div>
//   );
// };

// export default Updateservice;







// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals";

// const Updateservice = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const initialData = location.state?.responseData || {};
//   const [editableData, setEditableData] = useState(initialData);

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   useEffect(() => {
//     console.log("Received Data for Update:", editableData);
//   }, [editableData]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditableData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   const handleSaveChanges = async () => {
//     if (!editableData.ID || !editableData.ServiceName) {
//       toast.warn("⚠️ ID and Service Name are required.");
//       return;
//     }

//     const whereCondition = `ID=${editableData.ID}`;
//     const updateData = new URLSearchParams();
//     updateData.append("SecurityKey", SECURITY_KEY);
//     updateData.append("TableName", "ServiceMast");
//     updateData.append("WhereCondition", whereCondition);

//     Object.entries(editableData).forEach(([key, value]) => {
//       if (value !== undefined && value !== null && key !== "ID") {
//         updateData.append(key, value.toString());
//       }
//     });

//     try {
//       const response = await fetch(
//         // "https://etour.responseinfoway.com/restapi/updatedata.aspx",
//         // "https://etourrestapi.responseinfoway.com/restApi/updatedata.aspx",
//         `${BASE_REST_API_URL}/updatedata.aspx`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded",
//             Accept: "application/json",
//           },
//           body: updateData.toString(),
//         }
//       );

//       const textResponse = await response.text();
//       console.log("Raw API Response:", textResponse);

//       // ✅ Show toast first, then redirect
//       if (
//         textResponse.toLowerCase().includes("ok") ||
//         textResponse.toLowerCase().includes("success") ||
//         !textResponse.toLowerCase().includes("error")
//       ) {
//         toast.success("✅ Save changes successfully!", {
//           position: "top-right",
//           autoClose: 1000, // toast visible for 1.5s
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//         });

//         // Redirect after toast is visible
//         setTimeout(() => {
//           navigate("/showservice", { state: { updatedItem: editableData } });
//         }, 1600);
//       } else {
//         toast.error("❌ Update failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Update error:", error);
//       toast.error("❌ Network or server error!");
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

//       <form className="compney_form">
//         <h5 className="text-center font-bold m-3">Update Service</h5>

//         <div className="compney_input_div d-none">
//           <input type="text" name="ID" value={editableData.ID || ""} readOnly />
//         </div>

//         <div className="compney_input_div">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="ServiceName"
//             value={editableData.ServiceName || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Service Name"
//             required
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>HSN Code</label>
//           <input
//             type="text"
//             name="HSNCODE"
//             value={editableData.HSNCODE || ""}
//             onChange={handleInputChange}
//             placeholder="Enter HSN Code"
//           />
//         </div>

//         <div className="text-center mt-3">
//           <button type="button" onClick={handleSaveChanges}>
//             Save Changes
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Updateservice;



// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const Updateservice = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   const initialData = location.state?.responseData || {};
//   const [editableData, setEditableData] = useState(initialData);

//   const [taxList, setTaxList] = useState([]);
//   const [selectedTaxRate, setSelectedTaxRate] = useState("");

//   // --------------------------------------------------
//   // LOAD TAX LIST BASED ON CompID
//   // --------------------------------------------------
//   useEffect(() => {
//     if (!editableData.CompID) return;

//     fetch(`${BASE_API_URL}/api/servicemast/dropdown-tax/${editableData.CompID}`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status && data.data.length > 0) {
//           setTaxList(data.data);
//         }
//       })
//       .catch((err) => {
//         console.error("Tax Fetch Error:", err);
//         toast.error("Unable to load tax list");
//       });
//   }, [editableData.CompID]);

//   // --------------------------------------------------
//   // AUTO-FILL TAX RATE WHEN TAX ID CHANGED
//   // --------------------------------------------------
//   const handleTaxChange = (e) => {
//     const taxId = Number(e.target.value);

//     const selected = taxList.find((item) => item.ID === taxId);

//     setEditableData((prev) => ({
//       ...prev,
//       TaxID: taxId,
//     }));

//     setSelectedTaxRate(selected?.TaxRate || "");
//   };

//   // --------------------------------------------------
//   // ON INPUT CHANGE
//   // --------------------------------------------------
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditableData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   // --------------------------------------------------
//   // SAVE UPDATED DATA (PUT API)
//   // --------------------------------------------------
//   const handleSaveChanges = async () => {
//     if (!editableData.ID || !editableData.ServiceName) {
//       toast.warn("ID and Service Name are required.");
//       return;
//     }

//     const apiUrl = `${BASE_API_URL}/api/servicemast/update/${editableData.ID}`;

//     const payload = {
//       CompID: editableData.CompID,
//       ServiceName: editableData.ServiceName,
//       HSNCODE: editableData.HSNCODE,
//       TaxID: editableData.TaxID,
//       TaxRate: selectedTaxRate || editableData.TaxRate,
//       ShortCode: editableData.ShortCode || "",
//       Deleted: editableData.Deleted ?? 0,
//     };

//     try {
//       const response = await fetch(apiUrl, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const result = await response.json();

//       if (result.status) {
//         toast.success("Updated Successfully!");

//         setTimeout(() => {
//           navigate("/showservice", {
//             state: { updatedItem: editableData },
//           });
//         }, 1500);
//       } else {
//         toast.error(result.message || "Update failed!");
//       }
//     } catch (error) {
//       console.error("Update Error:", error);
//       toast.error("Network or Server Error!");
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

//       <form className="compney_form">
//         <h5 className="text-center font-bold m-3">Update Service</h5>

//         {/* SERVICE NAME */}
//         <div className="compney_input_div">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="ServiceName"
//             value={editableData.ServiceName || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Service Name"
//             required
//           />
//         </div>

//         {/* HSN CODE */}
//         <div className="compney_input_div">
//           <label>HSN Code</label>
//           <input
//             type="text"
//             name="HSNCODE"
//             value={editableData.HSNCODE || ""}
//             onChange={handleInputChange}
//             placeholder="Enter HSN Code"
//           />
//         </div>

//         {/* TAX DROPDOWN */}
//         <div className="compney_input_div">
//           <label>Tax</label>
//           <select
//             name="TaxID"
//             value={editableData.TaxID || ""}
//             onChange={handleTaxChange}
//           >
//             <option value="">Select Tax</option>
//             {taxList.map((tax) => (
//               <option key={tax.ID} value={tax.ID}>
//                 {tax.TaxName} ({tax.TaxRate}%)
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* TAX RATE */}
//         <div className="compney_input_div">
//           <label>Tax Rate (%)</label>
//           <input
//             type="text"
//             value={selectedTaxRate || editableData.TaxRate || ""}
//             readOnly
//           />
//         </div>

//         {/* SAVE BUTTON */}
//         <div className="text-center mt-3">
//           <button type="button" onClick={handleSaveChanges}>
//             Save Changes
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Updateservice;





// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const Updateservice = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   // ------------------------------------------
//   // LOAD DATA PASSED FROM SHOW SERVICE PAGE
//   // ------------------------------------------
//   const initialData = location.state?.responseData || {};
//   const [editableData, setEditableData] = useState(initialData);

//   const [taxList, setTaxList] = useState([]);
//   const [selectedTaxRate, setSelectedTaxRate] = useState("");

//   // --------------------------------------------------
//   // FETCH TAX LIST BASED ON CompID
//   // --------------------------------------------------
//   useEffect(() => {
//     if (!editableData.CompID || !BASE_API_URL) return;

//     fetch(`${BASE_API_URL}/api/servicemast/dropdown-tax/${editableData.CompID}`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status && data.data.length > 0) {
//           setTaxList(data.data);

//           // AUTO FILL TAXRATE FROM EXISTING DATA
//           const tax = data.data.find((t) => t.ID === editableData.TaxID);
//           if (tax) setSelectedTaxRate(tax.TaxRate);
//         }
//       })
//       .catch((err) => {
//         console.error("Tax Fetch Error:", err);
//         toast.error("Unable to load tax list");
//       });
//   }, [editableData.CompID, BASE_API_URL]);

//   // --------------------------------------------------
//   // ON TAX CHANGE
//   // --------------------------------------------------
//   const handleTaxChange = (e) => {
//     const taxId = Number(e.target.value);

//     const selected = taxList.find((item) => item.ID === taxId);

//     setEditableData((prev) => ({
//       ...prev,
//       TaxID: taxId,
//       TaxRate: selected?.TaxRate || "",
//     }));

//     setSelectedTaxRate(selected?.TaxRate || "");
//   };

//   // --------------------------------------------------
//   // ON INPUT CHANGE
//   // --------------------------------------------------
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditableData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   // --------------------------------------------------
//   // SAVE UPDATED DATA USING PUT API
//   // --------------------------------------------------
// const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (!editableData.ID) {
//     toast.error("Service ID is missing!");
//     return;
//   }

//   try {
//     const res = await fetch(
//       `${BASE_API_URL}/api/servicemast/update/${editableData.ID}`,
//       {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           CompID: editableData.CompID,
//           ServiceName: editableData.ServiceName,
//           HSNCODE: editableData.HSNCODE,
//           TaxID: editableData.TaxID,
//           ShortCode: editableData.ShortCode || "",
//           Deleted: editableData.Deleted || 0,
//         }),
//       }
//     );

//     const text = await res.text(); // read response text
//     let result;
//     try {
//       result = JSON.parse(text); // parse as JSON
//     } catch (err) {
//       console.error("Non-JSON response from server:", text);
//       toast.error("Server returned invalid response");
//       return;
//     }

//     if (result.status) {
//       toast.success("Service updated successfully!");
//       setTimeout(() => navigate("/showservice"), 1500);
//     } else {
//       toast.error(result.message || "Update failed!");
//     }
//   } catch (err) {
//     toast.error("Server error");
//     console.error(err);
//   }
// };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

//       <form className="compney_form" onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Update Service</h5>

//         {/* SERVICE NAME */}
//         <div className="compney_input_div">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="ServiceName"
//             value={editableData.ServiceName || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Service Name"
//             required
//           />
//         </div>

//         {/* HSN CODE */}
//         <div className="compney_input_div">
//           <label>HSN Code</label>
//           <input
//             type="text"
//             name="HSNCODE"
//             value={editableData.HSNCODE || ""}
//             onChange={handleInputChange}
//             placeholder="Enter HSN Code"
//           />
//         </div>

//         {/* TAX DROPDOWN */}
//         <div className="compney_input_div">
//           <label>Tax Name</label>
//           <select
//             name="TaxID"
//             value={editableData.TaxID || ""}
//             onChange={handleTaxChange}
//           >
//             <option value="">Select Tax</option>
//             {taxList.map((tax) => (
//               <option key={tax.ID} value={tax.ID}>
//                 {tax.TaxName} ({tax.TaxRate}%)
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* TAX RATE */}
//         <div className="compney_input_div">
//           <label>Tax Rate (%)</label>
//           <input
//             type="text"
//             value={selectedTaxRate || editableData.TaxRate || ""}
//             readOnly
//           />
//         </div>

//         {/* SAVE BUTTON */}
//         <div className="text-center mt-3">
//           <button type="submit">Save Changes</button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Updateservice;





// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const Updateservice = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   // ------------------------------------------
//   // LOAD DATA PASSED FROM SHOW SERVICE PAGE
//   // ------------------------------------------
//   const initialData = location.state?.responseData || {};
//   const [editableData, setEditableData] = useState(initialData);

//   const [taxList, setTaxList] = useState([]);
//   const [selectedTaxRate, setSelectedTaxRate] = useState("");

//   // --------------------------------------------------
//   // FETCH TAX LIST BASED ON CompID
//   // --------------------------------------------------
//   useEffect(() => {
//     if (!editableData.CompID || !BASE_API_URL) return;

//     fetch(`${BASE_API_URL}/api/servicemast/dropdown-tax/${editableData.CompID}`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status && data.data.length > 0) {
//           setTaxList(data.data);

//           // AUTO FILL TAXRATE FROM EXISTING DATA
//           const tax = data.data.find((t) => t.ID === editableData.TaxID);
//           if (tax) setSelectedTaxRate(tax.TaxRate);
//         }
//       })
//       .catch((err) => {
//         console.error("Tax Fetch Error:", err);
//         toast.error("Unable to load tax list");
//       });
//   }, [editableData.CompID, BASE_API_URL]);

//   // --------------------------------------------------
//   // ON TAX CHANGE
//   // --------------------------------------------------
//   const handleTaxChange = (e) => {
//     const taxId = Number(e.target.value);
//     const selected = taxList.find((item) => item.ID === taxId);

//     setEditableData((prev) => ({
//       ...prev,
//       TaxID: taxId,
//       TaxRate: selected?.TaxRate || prev.TaxRate,
//       TaxName: selected?.TaxName || prev.TaxName,
//     }));

//     setSelectedTaxRate(selected?.TaxRate || editableData.TaxRate);
//   };

//   // --------------------------------------------------
//   // ON INPUT CHANGE
//   // --------------------------------------------------
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditableData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   // --------------------------------------------------
//   // SAVE UPDATED DATA USING PUT API
//   // --------------------------------------------------
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!editableData.ID) {
//       toast.error("Service ID is missing!");
//       return;
//     }

//     // Only send the fields that exist (if user did not edit, previous value will stay)
//     const payload = {
//       CompID: editableData.CompID,
//       ServiceName: editableData.ServiceName,
//       HSNCODE: editableData.HSNCODE,
//       TaxID: editableData.TaxID,
//       TaxRate: selectedTaxRate,
//       TaxName: editableData.TaxName,
//       ShortCode: editableData.ShortCode || "",
//       Deleted: editableData.Deleted || 0,
//     };

//     try {
//       const res = await fetch(
//         `${BASE_API_URL}/api/servicemast/update/${editableData.ID}`,
//         {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         }
//       );

//       const text = await res.text(); // read response text
//       let result;
//       try {
//         result = JSON.parse(text); // parse as JSON
//       } catch (err) {
//         console.error("Non-JSON response from server:", text);
//         toast.error("Server returned invalid response");
//         return;
//       }

//       if (result.status) {
//         toast.success("Service updated successfully!");
//         setEditableData(result.data); // Update frontend immediately with saved data
//         setSelectedTaxRate(result.data.TaxRate || selectedTaxRate);
//         setTimeout(() => navigate("/showservice"), 1500);
//       } else {
//         toast.error(result.message || "Update failed!");
//       }
//     } catch (err) {
//       toast.error("Server error");
//       console.error(err);
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

//       <form className="compney_form" onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Update Service</h5>

//         {/* SERVICE NAME */}
//         <div className="compney_input_div">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="ServiceName"
//             value={editableData.ServiceName || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Service Name"
//             required
//           />
//         </div>

//         {/* HSN CODE */}
//         <div className="compney_input_div">
//           <label>HSN Code</label>
//           <input
//             type="text"
//             name="HSNCODE"
//             value={editableData.HSNCODE || ""}
//             onChange={handleInputChange}
//             placeholder="Enter HSN Code"
//             readOnly // HSN Code stays as original (if you want editable, remove readOnly)
//           />
//         </div>

//         {/* TAX DROPDOWN */}
//         <div className="compney_input_div">
//           <label>Tax Name</label>
//           <select
//             name="TaxID"
//             value={editableData.TaxID || ""}
//             onChange={handleTaxChange}
//           >
//             <option value="">Select Tax</option>
//             {taxList.map((tax) => (
//               <option key={tax.ID} value={tax.ID}>
//                 {tax.TaxName} ({tax.TaxRate}%)
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* TAX RATE */}
//         <div className="compney_input_div">
//           <label>Tax Rate (%)</label>
//           <input
//             type="text"
//             value={selectedTaxRate || editableData.TaxRate || ""}
//             readOnly
//           />
//         </div>

//         {/* SAVE BUTTON */}
//         <div className="text-center mt-3">
//           <button type="submit">Save Changes</button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Updateservice;






// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const Updateservice = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   // ------------------------------------------
//   // LOAD DATA PASSED FROM SHOW SERVICE PAGE
//   // ------------------------------------------
//   const initialData = location.state?.responseData || {};
//   const [editableData, setEditableData] = useState(initialData);

//   const [taxList, setTaxList] = useState([]);
//   const [selectedTaxRate, setSelectedTaxRate] = useState("");

//   // --------------------------------------------------
//   // FETCH TAX LIST BASED ON CompID
//   // --------------------------------------------------
//   useEffect(() => {
//     if (!editableData.CompID || !BASE_API_URL) return;

//     fetch(`${BASE_API_URL}/api/servicemast/dropdown-tax/${editableData.CompID}`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status && data.data.length > 0) {
//           setTaxList(data.data);

//           // AUTO FILL TAXRATE AND TAXID FROM EXISTING DATA
//           const tax = data.data.find((t) => t.ID === editableData.TaxID);
//           if (tax) {
//             setSelectedTaxRate(tax.TaxRate);
//             setEditableData((prev) => ({
//               ...prev,
//               TaxID: tax.ID,
//               TaxName: tax.TaxName,
//               TaxRate: tax.TaxRate,
//             }));
//           }
//         }
//       })
//       .catch((err) => {
//         console.error("Tax Fetch Error:", err);
//         toast.error("Unable to load tax list");
//       });
//   }, [editableData.CompID, BASE_API_URL]);

//   // --------------------------------------------------
//   // ON TAX CHANGE
//   // --------------------------------------------------
//   const handleTaxChange = (e) => {
//     const taxId = Number(e.target.value);
//     const selected = taxList.find((item) => item.ID === taxId);

//     if (selected) {
//       setEditableData((prev) => ({
//         ...prev,
//         TaxID: selected.ID,
//         TaxName: selected.TaxName,
//         TaxRate: selected.TaxRate,
//       }));
//       setSelectedTaxRate(selected.TaxRate);
//     }
//   };

//   // --------------------------------------------------
//   // ON INPUT CHANGE
//   // --------------------------------------------------
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditableData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   // --------------------------------------------------
//   // SAVE UPDATED DATA USING PUT API
//   // --------------------------------------------------
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!editableData.ID) {
//       toast.error("Service ID is missing!");
//       return;
//     }

//     const payload = {
//       CompID: editableData.CompID,
//       ServiceName: editableData.ServiceName,
//       HSNCODE: editableData.HSNCODE,
//       TaxID: editableData.TaxID,
//       TaxRate: selectedTaxRate,
//       TaxName: editableData.TaxName,
//       ShortCode: editableData.ShortCode || "",
//       Deleted: editableData.Deleted || 0,
//     };

//     try {
//       const res = await fetch(
//         `${BASE_API_URL}/api/servicemast/update/${editableData.ID}`,
//         {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         }
//       );

//       const text = await res.text(); // read response text
//       let result;
//       try {
//         result = JSON.parse(text);
//       } catch (err) {
//         console.error("Non-JSON response from server:", text);
//         toast.error("Server returned invalid response");
//         return;
//       }

//       if (result.status) {
//         toast.success("Service updated successfully!");
//         setEditableData(result.data); // update frontend immediately
//         setSelectedTaxRate(result.data.TaxRate || selectedTaxRate);
//         setTimeout(() => navigate("/showservice"), 1500);
//       } else {
//         toast.error(result.message || "Update failed!");
//       }
//     } catch (err) {
//       toast.error("Server error");
//       console.error(err);
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

//       <form className="compney_form" onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Update Service</h5>

//         {/* SERVICE NAME */}
//         <div className="compney_input_div">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="ServiceName"
//             value={editableData.ServiceName || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Service Name"
//             required
//           />
//         </div>

//         {/* HSN CODE */}
//         <div className="compney_input_div">
//           <label>HSN Code</label>
//           <input
//             type="text"
//             name="HSNCODE"
//             value={editableData.HSNCODE || ""}
//             onChange={handleInputChange}
//             readOnly // HSN code stays the same
//           />
//         </div>

//         {/* TAX DROPDOWN */}
//         <div className="compney_input_div">
//           <label>Tax Name</label>
//           <select
//             name="TaxID"
//             value={editableData.TaxID || ""}
//             onChange={handleTaxChange}
//           >
//             <option value="">Select Tax</option>
//             {taxList.map((tax) => (
//               <option key={tax.ID} value={tax.ID}>
//                 {tax.TaxName} ({tax.TaxRate}%)
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* TAX RATE */}
//         <div className="compney_input_div">
//           <label>Tax Rate (%)</label>
//           <input
//             type="text"
//             value={selectedTaxRate || editableData.TaxRate || ""}
//             readOnly
//           />
//         </div>

//         {/* SAVE BUTTON */}
//         <div className="text-center mt-3">
//           <button type="submit">Save Changes</button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Updateservice;






import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import "../Ledger/UpdateLedger.css";
import "./service.css";
import { apiWithLog } from "../../../utils/apiWithLog";

const Updateservice = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTaxRow, setActiveTaxRow] = useState(false);
  const [loading, setLoading] = useState(false);

  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  const savedCompany = JSON.parse(localStorage.getItem("selectedCompany") || "{}");
  const activeCompId = location.state?.responseData?.CompID || localStorage.getItem("CompID") || savedCompany?.id;

  // ------------------------------------------
  // LOAD DATA PASSED FROM SHOW SERVICE PAGE
  // ------------------------------------------
  const initialData = location.state?.responseData || {};
  const [editableData, setEditableData] = useState({
    ...initialData,
    CompID: initialData.CompID || activeCompId,
  });

  const [taxList, setTaxList] = useState([]);
  const [selectedTaxRate, setSelectedTaxRate] = useState(initialData.TaxRate || "");

  // --------------------------------------------------
  // CHECK FOR MISSING DATA ON LOAD
  // --------------------------------------------------
  useEffect(() => {
    if (!initialData.ServiceName && !initialData.ID && initialData.ID !== 0) {
      showToast.error("No service selected. Please pick a service from the list.");
    }
  }, []);

  // --------------------------------------------------
  // FETCH TAX LIST BASED ON CompID
  // --------------------------------------------------
  useEffect(() => {
    const compIdToUse = editableData.CompID || activeCompId;
    if (!compIdToUse || !BASE_API_URL) return;

    fetch(`${BASE_API_URL}/servicemast/dropdown-tax/${compIdToUse}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status && data.data.length > 0) {
          setTaxList(data.data);

          // AUTO FILL TAXRATE AND TAXID FROM EXISTING DATA
          const tax = data.data.find((t) => t.ID === editableData.TaxID);
          if (tax) {
            setSelectedTaxRate(tax.TaxRate);
            setEditableData((prev) => ({
              ...prev,
              TaxID: tax.ID,
              TaxName: tax.TaxName,
              TaxRate: tax.TaxRate,
            }));
          }
        }
      })
      .catch((err) => {
        console.error("Tax Fetch Error:", err);
        showToast.error("Unable to load tax list");
      });
  }, [editableData.CompID, activeCompId, BASE_API_URL]);

  // --------------------------------------------------
  // ON TAX CHANGE
  // --------------------------------------------------
  const handleTaxChange = (tax) => {
    setEditableData((prev) => ({
      ...prev,
      TaxID: tax.ID,
      TaxName: tax.TaxName,
      TaxRate: tax.TaxRate,
    }));
    setSelectedTaxRate(tax.TaxRate);
    setActiveTaxRow(false); // close dropdown
  };

  // --------------------------------------------------
  // ON INPUT CHANGE
  // --------------------------------------------------
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const compIdToUse = editableData.CompID || activeCompId;
    if (!compIdToUse) {
      showToast.error("Company not selected!");
      return;
    }

    if (!editableData.ServiceName || !editableData.ServiceName.trim()) {
      showToast.error("Service Name is required!");
      return;
    }

    const isNewService = !editableData.ID || editableData.ID === 0;

    const payload = {
      CompID: compIdToUse,
      ServiceName: editableData.ServiceName,
      HSNCODE: editableData.HSNCODE || "",
      TaxID: editableData.TaxID || null,
      TaxRate: selectedTaxRate || 0,
      TaxName: editableData.TaxName || "",
      ShortCode: editableData.ShortCode || "code",
      Unit: editableData.Unit || "",
      Deleted: editableData.Deleted || 0,
    };

    try {
      setLoading(true);
      const url = isNewService
        ? `${BASE_API_URL}/servicemast/add`
        : `${BASE_API_URL}/servicemast/update/${editableData.ID}`;
      const method = isNewService ? "POST" : "PUT";
      const action = isNewService ? "A" : "E";

      // ===== API with Logging =====
      const res = await apiWithLog({
        method,
        url,
        data: payload,
        module: "ServiceMaster",
        action,
        headers: {
          "Content-Type": "application/json",
        },
      });

      const text =
        typeof res.data === "string"
          ? res.data
          : JSON.stringify(res.data);

      let result;
      try {
        result = typeof text === "string" ? JSON.parse(text) : text;
      } catch (err) {
        console.error("Non-JSON response from server:", text);
        showToast.error("Server returned invalid response");
        return;
      }

      if (result.status || res.status === 200) {
        showToast.save(isNewService ? "Service added successfully!" : "Service updated successfully!");
        setEditableData(result.data || editableData);
        setSelectedTaxRate(
          result?.data?.TaxRate || selectedTaxRate
        );

        setTimeout(() => navigate("/showservice"), 1200);
      } else {
        showToast.error(result.message || "Operation failed!");
      }
    } catch (err) {
      console.error("Service Update Error:", err);
      showToast.error(err?.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update_ledger_container">
      {/* Header & Breadcrumbs */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h4 className="update_ledger_title">Update Service</h4>
          <div className="update_ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <Link to="/showservice">Services</Link>
            <span>/</span>
            <span>Update</span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>Service Details</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="update_ledger_grid">
            {/* SERVICE NAME */}
            <div className="update_ledger_field">
              <label htmlFor="ServiceName">
                Service Name <span className="required">*</span>
              </label>
              <input
                id="ServiceName"
                type="text"
                name="ServiceName"
                value={editableData.ServiceName || ""}
                onChange={handleInputChange}
                placeholder="Enter Service Name"
                required
              />
            </div>

            {/* HSN CODE */}
            <div className="update_ledger_field">
              <label htmlFor="HSNCODE">HSN Code</label>
              <input
                id="HSNCODE"
                type="text"
                name="HSNCODE"
                value={editableData.HSNCODE || ""}
                onChange={handleInputChange}
                placeholder="e.g. 9964"
              />
            </div>

            {/* TAX DROPDOWN */}
            <div className="update_ledger_field">
              <label htmlFor="TaxName">Tax Name</label>
              <div className="service-dropdown-wrapper">
                <input
                  id="TaxName"
                  value={editableData.TaxName || ""}
                  onChange={(e) =>
                    setEditableData((prev) => ({
                      ...prev,
                      TaxName: e.target.value,
                    }))
                  }
                  onFocus={() => setActiveTaxRow(true)}
                  onBlur={() => setTimeout(() => setActiveTaxRow(false), 150)}
                  placeholder="-- Select Tax --"
                />

                {/* TAX DROPDOWN LIST */}
                {activeTaxRow && (
                  <ul className="service-dropdown-list">
                    {taxList.map((tax) => (
                      <li
                        key={tax.ID}
                        onMouseDown={() => handleTaxChange(tax)}
                      >
                        {tax.TaxName} ({tax.TaxRate}%)
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            {/* TAX RATE */}
            <div className="update_ledger_field">
              <label htmlFor="TaxRate">Tax Rate (%)</label>
              <input
                id="TaxRate"
                type="text"
                value={selectedTaxRate || editableData.TaxRate || ""}
                placeholder="0"
                readOnly
              />
            </div>

            {/* UNIT */}
            <div className="update_ledger_field">
              <label htmlFor="Unit">Default Unit</label>
              <select
                id="Unit"
                name="Unit"
                value={editableData.Unit || ""}
                onChange={handleInputChange}
              >
                <option value="">-- Select Unit --</option>
                <option value="Trip">Trip</option>
                <option value="Day">Day</option>
                <option value="Lump Sum">Lump Sum</option>
                <option value="No.">No.</option>
                <option value="Month">Month</option>
                <option value="Km">Km</option>
                <option value="Hr">Hr</option>
              </select>
            </div>
          </div>

          <div className="update_ledger_actions">
            <Link to="/showservice" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button type="submit" className="update_ledger_submit_btn" disabled={loading}>
              {loading ? "Saving Changes..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Updateservice;
